//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        title: {
            type: String
        },
        rate_opts: {
            type: Array
        },
        discount_opts: {
            type: Array
        },
        default_rate: {
            type: Number
        },
        default_discount: {
            type: Number
        }
    },
    data () {
        return {
            rate: this.default_rate,
            discount: this.default_discount,
            custom_rate: ''
        }
    },
    mounted () {
        this.moveScroll()
    },
    methods: {
        moveScroll () {
            if (this.$el && typeof this.$el.querySelector === 'function') {
                const $active_els = this.$el.querySelectorAll('.active')
                if ($active_els && $active_els.length) {
                    $active_els.forEach(($item) => {
                        $item.scrollIntoView()
                    })
                }
            }
        },
        changeRate (i) {
            this.rate = i
        },
        changeDiscount (i) {
            this.discount = i
        },
        confirmPicker () {
            this.$emit('changePicker', this.rate, this.discount)
            this.hide()
        },
        confirmCustom () {
            const rate = Number(this.custom_rate)
            if (rate && !isNaN(rate)) {
                this.$emit('change', rate)
                this.hide()
            } else {
                this.$wx.showToast({
                    title: '请填写正确的利率',
                    icon: 'none'
                })
            }
        },
        hide () {
            this.$emit('hide')
        }
    }
}
